// src/pages/TwoFactorEnablePage.jsx
import React, { useEffect, useState } from "react";
import api from "../api/api";
import twoFactorService from "../api/twoFactorService";

const TwoFactorEnablePage = () => {
    const [me, setMe] = useState(null);
    const [qrSrc, setQrSrc] = useState(null);
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    // =========================
    // Load current user
    // =========================
    const loadMe = async () => {
        try {
            const res = await api.get("/login/me");
            setMe(res.data);
        } catch (e) {
            console.error("Failed to load current user:", e);
            setError("Failed to load current user (check token).");
        }
    };

    useEffect(() => {
        loadMe();
    }, []);



    // =========================
    // Generate QR (SETUP)
    // =========================
    const handleEnable2FA = async () => {
        setMessage("");
        setError("");

        try {
            setLoading(true);

            setQrSrc(null);
            setQrSrc(null);

            const qrUrl = await twoFactorService.setup2FA();
            setQrSrc(qrUrl);

            setMessage("📷 Scan QR in Google Authenticator, then confirm using the code.");

            // 🔁 reload user info
            await loadMe();

        } catch (e) {
            console.error("Failed to generate 2FA QR:", e);
            setError("❌ Failed to generate QR code.");
        } finally {
            setLoading(false);
        }
    };
    const handleConfirm2FA = async () => {
        setMessage("");
        setError("");

        if (!code.trim()) {
            setError("Enter verification code.");
            return;
        }

        try {
            setLoading(true);

            await twoFactorService.confirm2FA(code.trim());

            setMessage("✅ 2FA enabled successfully.");
            setQrSrc(null);
            setCode("");

            await loadMe();
        } catch (e) {
            console.error(e);
            setError("❌ Invalid verification code.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow">
            <h1 className="text-2xl font-bold mb-4">
                Two-Factor Authentication
            </h1>

            {me && (
                <>
                    <p className="mb-2 text-sm text-gray-600">
                        Logged in as:{" "}
                        <strong>{me.email || me.userName || me.id}</strong>
                    </p>

                    <p className="mb-4">
                        2FA Status:{" "}
                        <span className={`font-semibold ${me.isTwoFactorEnabled
                                ? "text-green-600"
                                : "text-red-600"
                            }`}>
                            {me.isTwoFactorEnabled ? "Enabled ✅" : "Disabled ❌"}
                        </span>
                    </p>
                </>
            )}

            {error && <p className="text-red-600 mb-2">{error}</p>}
            {message && <p className="text-green-600 mb-2">{message}</p>}

            {!me?.isTwoFactorEnabled && (
                <button
                    type="button"
                    onClick={handleEnable2FA}
                    disabled={loading}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-60"
                >
                    {loading ? "Generating..." : "Generate QR for 2FA"}
                </button>
            )}

            {qrSrc && (
                <div className="mt-6 text-center">
                    <img
                        src={qrSrc}
                        alt="2FA QR Code"
                        className="mx-auto border rounded p-2 bg-gray-50"
                    />

                    <p className="mt-2 text-sm text-gray-700">
                        After scanning, enter the code from Google Authenticator.
                    </p>

                    <input
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="123456"
                        className="mt-4 border rounded px-3 py-2 w-full"
                    />

                    <button
                        type="button"
                        onClick={handleConfirm2FA}
                        disabled={loading}
                        className="mt-3 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    >
                        Confirm & Enable 2FA
                    </button>
                </div>
            )}
        </div>
    );
};

export default TwoFactorEnablePage;